import { render, staticRenderFns } from "./EnAbout.vue?vue&type=template&id=34b6dbc4&scoped=true&"
import script from "./EnAbout.vue?vue&type=script&lang=js&"
export * from "./EnAbout.vue?vue&type=script&lang=js&"
import style0 from "./EnAbout.vue?vue&type=style&index=0&id=34b6dbc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6dbc4",
  null
  
)

export default component.exports